import React from "react";

class GithubRepos extends React.Component {
    constructor(props) {
        super(props);
    }


    render() {
        
        return (
            <React.Fragment>
                <div className="card">
                    <div className="card-header bg-danger">
                        <h3 className="text-white">Github Repos</h3>
                    </div>
                    <div className="card-body ">
                            {
                                this.props.repos.map((repo) => {
                                    return(
                                        <ul className="list-group bg-warning">
                                        <li className=" list-group-item">
                                            <a className="bg-info text-white text-decoration-none" href={repo.html_url} target="_blank">{repo.name}</a>
                                            <span className="badge bg-primary mx-5">{repo.stargazers_count} Star</span>
                                            <span className="badge bg-warning mx-5">{repo.watchers_count} Watches</span>

                                        </li>
                                        </ul>
                                    )})
                            }
                       
                    </div>
                </div>
            </React.Fragment>
        )
    }

}

export default GithubRepos